<script setup lang="ts">
defineProps<{ loading?: boolean, blocking?: boolean }>();
</script>

<template>
    <div
        class="kgr-loadingContainer"
        :class="{ 'is-loading': loading, 'is-blocking': blocking }"
    >
        <!-- Only render the loader while loading: with is-blocking it sets pointer-events:all and would
             otherwise capture clicks over the content. Mirrors the Angular directive's portal attach/detach. -->
        <div
            v-if="loading"
            class="kgr-loadingContainer__loader"
        >
            <div class="kgr-loadingContainer__loadingIndicator kgr-loadingIndicator"></div>
        </div>
        <slot></slot>
    </div>
</template>
